import { Link } from 'react-router-dom';
import SectionHeading from '@/components/base/SectionHeading';
import { topics } from '@/mocks/topics';

export default function TopicSection() {
  return (
    <section id="topics" className="w-full px-4 py-4 md:px-8">
      <SectionHeading title="特色专题" subtitle="编辑部精心策划的合集，一次看个够" />
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 lg:gap-5">
        {topics.map((topic) => (
          <Link
            key={topic.id}
            to={`/search?q=${encodeURIComponent(topic.tag)}`}
            className="group relative flex h-56 cursor-pointer flex-col justify-end overflow-hidden rounded-lg border border-background-200"
          >
            <img
              src={topic.cover}
              alt={`${topic.title}专题封面`}
              className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/40 to-foreground-950/10" />
            <div className="relative z-10 p-4">
              <span className="mb-2 inline-block rounded-md bg-accent-500 px-2 py-0.5 text-xs font-label font-700 text-foreground-950">
                {topic.tag}
              </span>
              <h3 className="font-heading text-lg font-700 text-background-50">{topic.title}</h3>
              <p className="mt-1 line-clamp-2 text-xs leading-relaxed text-background-100/85">{topic.desc}</p>
              <span className="mt-2 flex items-center gap-1 text-xs font-label text-background-100/90">
                <i className="ri-file-list-3-line" />
                共 {topic.count} 篇内容
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}